import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  FDBox, FDLabelText, FDStack, FDTooltip,
} from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const metaOverrideSet = (isMobile) => fr.metaOverride()
  .nameOverride('subject', {
    _component: Text,
    _customProps: {
      color: 'black',
      variant: isMobile ? 'h5' : 'h4',
      weight: 'medium',
      align: 'left',
    },
    _hideLabel: true,
  }, { ordinal: 200 });


const useStyles = buildUseStyles('ThreadSubject', (theme) => ({
  subject: {
    paddingBottom: theme.spacing(0),
    lineHeight: 1.5,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
  },
}));

const ThreadSubject = ({
  threadResource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();

  return (
    <FDTooltip title={threadResource.attr('subject')}>
      <FDBox minWidth={0} flexGrow={1}>
        <FDStack direction={'column'} alignItems={'flex-start'}>
          <FDBox paddingX={1} width={'100%'} overflow={'hidden'}>
            {threadResource.attr('subject') && !isMobile
              ? <FDLabelText value={threadResource.meta().field('subject').attr('prompt')} size={'lg'} />
              : null }
            <MetaControl
              className={classes.subject}
              metaOverrideSet={metaOverrideSet(isMobile)}
              resource={threadResource}
              attrName={'subject'}
            />
          </FDBox>
        </FDStack>
      </FDBox>
    </FDTooltip>
  );
};

ThreadSubject.defaultProps = {
};

ThreadSubject.propTypes = {
  threadResource: PropTypes.object.isRequired,
};

export { ThreadSubject };
